/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Studio_Prompt_LabelInputs */

const en_landing_studio_prompt_label = /** @type {(inputs: Landing_Studio_Prompt_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prompt`)
};

const zh_landing_studio_prompt_label = /** @type {(inputs: Landing_Studio_Prompt_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提示词`)
};

/**
* | output |
* | --- |
* | "Prompt" |
*
* @param {Landing_Studio_Prompt_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_studio_prompt_label = /** @type {((inputs?: Landing_Studio_Prompt_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Studio_Prompt_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_studio_prompt_label(inputs)
	return zh_landing_studio_prompt_label(inputs)
});
export { landing_studio_prompt_label as "landing.studio.prompt_label" }